import TopNav from "../components/TopNav.jsx";
import ProductMark from "../components/ProductMark.jsx";
import FreeConsultWidget from "../components/FreeConsultWidget.jsx";

/**
 * BeaconPage · /beacon
 * Free forever · first-responder software (EMTs, dispatch, fire crews).
 */
export default function BeaconPage() {
  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain" data-testid="beacon-page">
      <TopNav />
      <div className="mx-auto max-w-4xl px-4 md:px-8 py-12">
        <div className="text-[10px] uppercase tracking-[0.3em] text-sage-accent mb-3">FREE FOREVER · PUBLIC-SERVICE TIER</div>
        <div className="flex items-start gap-4 mb-4">
          <div className="text-sage-accent shrink-0"><ProductMark slug="beacon" size={48} /></div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tighter uppercase">Beacon</h1>
        </div>
        <p className="text-lg text-sage-muted leading-relaxed max-w-3xl mb-10 sage-prose">
          A working shift-companion for first responders. Free forever. No login, no cost, no tracking. Sage sits between the radio and the paperwork so you can move.
        </p>

        <div className="border border-sage-border p-6 mb-10">
          <div className="text-xs uppercase tracking-[0.15em] text-sage-muted mb-3">Who it's for</div>
          <ul className="list-disc list-inside text-sm text-sage-text space-y-2 sage-prose">
            <li>EMTs, paramedics, and ambulance dispatch</li>
            <li>Firefighters and wildland crews</li>
            <li>Search-and-rescue teams and community first responders</li>
            <li>Volunteer disaster-relief operators on the ground</li>
          </ul>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-10">
          <div className="border border-sage-border p-4" data-testid="beacon-feature-1">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Run-report drafting</div>
            <div className="text-xs text-sage-muted sage-prose">Dictate the call, get a clean draft report you can review and sign before end of shift.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="beacon-feature-2">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Protocol lookup</div>
            <div className="text-xs text-sage-muted sage-prose">Fast plain-english lookup for regional and national protocols. Cross-checked against public sources.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="beacon-feature-3">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Family notification drafts</div>
            <div className="text-xs text-sage-muted sage-prose">Draft the hardest calls in a voice that's honest, calm, and not corporate. Never sent for you.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="beacon-feature-4">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Shift-end brief</div>
            <div className="text-xs text-sage-muted sage-prose">One paragraph that sums the shift for the next crew. Handoff without a novel.</div>
          </div>
        </div>

        <div className="mb-10">
          <h2 className="text-2xl font-bold uppercase tracking-tight text-sage-text mb-3">Try it now — anonymous</h2>
          <FreeConsultWidget
            role="beacon-first-responder"
            productSlug="beacon"
            placeholder="Describe the call, the situation, or the protocol you're checking. Plain English is fine."
            ctaLabel="Ask Beacon"
            disclaimer="Beacon is a helper, not a replacement for training, protocol, or medical direction. Follow your service's chain of command."
          />
        </div>

        <div className="border-t border-sage-border pt-6 text-xs text-sage-muted sage-prose">
          Beacon costs Sage's till, not yours. It stays free forever — this is the greedless pledge in ink. If your department wants Beacon deployed with your own protocol library and dispatch integration, reach out through the Contact door.
        </div>
      </div>
    </div>
  );
}
